// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 957 ? "routes" : chunkId) + "." + {"865":"39a27309","957":"d42d6ca3"}[chunkId] + ".chunk.js";
};